import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const { applySession } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;

    const finish = (path) => {
      window.history.replaceState(null, "", window.location.pathname);
      navigate(path, { replace: true });
    };

    if (!sessionId) { finish("/auth"); return; }

    api
      .post("/auth/google-session", {}, { headers: { "X-Session-ID": sessionId } })
      .then((res) => { applySession(res.data); finish("/feed"); })
      .catch(() => finish("/auth"));
  }, [navigate, applySession]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-[#FAF9F6]">
      <Loader2 className="w-8 h-8 text-[#2C2A29] animate-spin" />
      <p className="font-decree text-xl text-[#4A4744] mt-6">Signing you in…</p>
    </div>
  );
}
